import $ from 'jquery';
import _ from 'lodash';
import Immutable from 'immutable';
import requestFrame from 'request-frame'; // requestAnimationFrame polyfill
import cx from '../../utils/cx.js';
import React from 'react';
import ReactDOM from 'react-dom';
import Constants from '../../constants/Constants';
import ConversationActionCreators from '../../actions/ConversationActionCreators.js';
import ConversationStore from '../../stores/ConversationStore';
import MemberStore from '../../stores/MemberStore';
import MessageItem from '../messages/MessageItem.react';
import GalleryStore from '../../stores/GalleryStore';
import Emojify from '../misc/Emojify.react';
import Linkify from '../misc/Linkify.react';
import ManipulateText from '../misc/ManipulateText.react';
import popup from '../../../app/popup.js';
import modal from '../../../app/modal.js';
import Scrollbars from './../misc/Scrollbars.react.js';
import ImageSvg from '../images/ImageSvg.react';
import { CSSTransition } from 'react-transition-group';

// var ReactPropTypes = React.PropTypes;

const Params = Constants.Params;
const request = requestFrame('request'); // requestAnimationFrame polyfill
const body = $('body');
const mainHeader = $('#header');
const mainTopBar = $('#topBar'); // Augšējā paziņojuma josla - admin un unverified lietotājiem
const minHeight = 153; // min augstums, ja aktīvs adbox laukums
const adboxHeight = 275; // adbox reklāmas laukuma augstums

function getStateFromStores() {
  const checked = ConversationStore.getChecked();
  return {
    conversations: ConversationStore.getAll(),
    lastConversation: ConversationStore.getLast(),
    lastReceivedCount: ConversationStore.getLastReceivedCount(),
    currentConversationID: ConversationStore.getCurrentID(),
    members: MemberStore.getAll(),
    unread: ConversationStore.getUnread(),
    limitedMessages: MemberStore.getLimitedMessages(),
    hasPaid: MemberStore.getHasPaid(),
    total: ConversationStore.getTotal(),
    checked: Immutable.fromJS(checked), // atzīmētās sarakstes
    // vai ir nospiesta load more poga
    loadMoreActive: ConversationStore.getLoadMore(),
    openConversationsCount: ConversationStore.getOpenConversationsCount(),
  };
}

function textTrim(text) {
  const allowed = 78; // simbolu skaits

  // ja teksts ir garāks, nogriež un pieliek "..."
  if (text.length > allowed) {
    text = `${text.substring(0, allowed)}...`;
  }

  return text;
}


class ConversationSection extends React.PureComponent {
  static displayName = 'ConversationSection';

  constructor(props) {
    super(props);
    const store = getStateFromStores();
    // pievieno scrollHeight, kuru vajag tikai pie init pievienot
    store.scrollHeight = 0;

    this.state = {
      data: Immutable.Map(store),
      conversationsEditor: false,
      deleting: false,
    };
  }

  // propTypes: {
  //
  // },
  //
  // getDefaultProps: function() {
  // 	return {
  //
  // 	};
  // },
  setImmState = fn => this.setState((prevState) => {
    const data = prevState.data;
    return {
      data: fn(data),
    };
  });

  // http://stackoverflow.com/a/28748160
  scrollElement = () => {
    // store a this ref, and
    const _this = this;
    // wait for a paint to do scrolly stuff
    request(() => {
      const ref = _.get(_this.refs, 'conversationScroll', false);
      if (ref) {
        _this.refs.conversationScroll.getInstance().scrollToTop();
      }
    });
  };

  // sarakstu skrollējamās daļas augstums, pielāgoja lapas augstumam
  setScrollHeight = () => {
    const data = this.state.data;
    const windowHeight = $(window).height();

    let scrollHeight = windowHeight - mainHeader.height() - parseInt(body.css('margin-bottom'));

    if (!this.props.mobile) {
      scrollHeight -= ReactDOM.findDOMNode(this.refs.header).offsetHeight;
    }

    if (mainTopBar.length) {
      scrollHeight -= mainTopBar.outerHeight();
    }

    // aktīvs adbox, samazina augsutms, lai vieta banerim
    if (_.get(globals, 'adbox', false)) {
      scrollHeight -= adboxHeight;

      if (scrollHeight < minHeight) {
        scrollHeight = minHeight;
      }
    }

    // nomainta State scrollHeight vērtību
    if (data.get('scrollHeight') != scrollHeight) {
      this.setImmState(data => data.update('scrollHeight', item => scrollHeight));
    }
  };

  componentDidMount() {
    window.addEventListener('resize', this._onResize);
    ConversationStore.addChangeListener(this._onChange);
    MemberStore.addChangeListener(this._onChange);
    this.setScrollHeight();
    this.scrollElement();

    // init adbox script
    if (_.get(globals, 'adbox', false) && window.inxBX != undefined) {
      inxBX.placement({ id: 'page_nmr' }, 1);
    }
  }

  componentWillUnmount() {
    const element = ReactDOM.findDOMNode(this);

    window.removeEventListener('resize', this._onResize);
    ConversationStore.removeChangeListener(this._onChange);
    MemberStore.removeChangeListener(this._onChange);
  }

  componentDidUpdate() {
    this.setScrollHeight();
    /* this.scrollElement(); */
    if (!this.state.data.get('total')) {
      if (!this.state.deleting) {
        this.setState({ deleting: true });
      }
    } else if (this.state.deleting) {
      this.setState({ deleting: false });
    }
  }

  render() {
    let loadMore = true;
    const data = this.state.data;
    const self = this;
    const showConversationsEditor = this.state.conversationsEditor;
    const deleting = this.state.deleting;

    // vai rādīt load more pogu
    if ((data.get('openConversationsCount') !== false && data.get('openConversationsCount') < Params.conversationsPage)
      || (data.get('lastReceivedCount') !== null && data.get('lastReceivedCount') < Params.conversationsPage)
    ) {
      loadMore = false;
    }

    let conversationItems = null;

    if (data.get('total')) {
      const members = data.get('members');
      const hasPaid = data.get('hasPaid');
      conversationItems = data.get('conversations').toArray().map(function (conversation) {
        const id = conversation.get('id');
        const unread = conversation.get('unread');
        const deleted = conversation.get('deleted');
        const memberId = (members[id] ? members[id]._id : null);
        let text = null;
        let date = null;
        let active = false;
        const onClick = this._onClick.bind(this, id);
        const onChecked = this._onChecked.bind(this, id);
        let unreadSent = false;

        // vai sarakstei ir norādīta pēdēja vēstule

	      if (members[id].blocked == true) {
	        text = [
	          <div key={id} className="tcr twb">
	            {_.get(translations, 'txt: Jūs esat bloķējis šo lietotāju!', '')}
	          </div>,
	        ];
	      } else if (conversation.get('message')) {
	        text = conversation.message.get('text');
	        text = [
	          <div key={id}>
	            <ManipulateText callback={textTrim}>
	              <Linkify
	                onlyImages
	                thumbSize="t"
	                imageLink={false}
	                messageId={conversation.message.get('_id')}
	                showUncensored={memberId != conversation.message.get('sender_id')}
	              >
	                <Emojify>{text}</Emojify>
	              </Linkify>
	            </ManipulateText>
	          </div>,
	        ];
	        date = conversation.get('message').get('created');

          // izsūtīta vēl neizlasīta vēstule
          if (hasPaid && memberId != conversation.message.get('sender_id') && !conversation.message.get('read')) {
            unreadSent = true;
          }
        }

        if (id == data.get('currentConversationID')) {
          active = true;
          unreadSent = false;
        }

        return (
          <div key={id}>
            <MessageItem
              id={`conversation_${memberId}`}
              memberId={memberId}
              verified={members[id].verified}
              messageId={id}
              new={unread}
              unread={unreadSent}
              deleted={deleted}
              truncateName={8}
              showDay
              text={text}
              pointer
              date={date}
              active={active}
              disableUserLink
              checked={data.get('checked').get(memberId)}
              onClick={onClick}
              onChecked={onChecked}
              showCheckboxes={showConversationsEditor}
            />
            <div className="messages-line" />
          </div>
        );
      }, this);

      // vai rādīt load more pogu
      if (loadMore && conversationItems !== null) {
        const loadMoreButton = function () {
          return (
            <div className="tac pas" key="loadMore">
              <a
                className={cx([
                  'btn btn--small btn--c',
                  ['has-loader', data.get('loadMoreActive')],
                ])}
                onClick={self._onClickLoadMore}
              >
                {_.get(translations, 'txt: Ielādēt vairāk', '')}
              </a>
            </div>
          );
        };
        conversationItems.push(loadMoreButton());
      }
    }

    // adbox elements
    const AdboxBlock = function () {
      if (!_.get(globals, 'adbox', false)) {
        return (<div />);
      }

      const urlToPayments = `${_.get(globals, 'webroot', '')}/payments/subscription`;
      return (
        <div className="adbox adbox--nmr">
          <div className="adbox-close">
            <a href={urlToPayments} data-noads-message>{_.get(translations, 'txt: Aizvērt reklāmu', '')}</a>
          </div>
          <div id="page_nmr" className="hide" />
        </div>
      );
    };

    const btnEdit = function () {
      if (!data.get('conversations').size || showConversationsEditor) {
        return;
      }

      return (
        <div className="messagesSide-header-edit">
          <a onClick={self._onClickEdit} className="btn btn--small btn--d">
            {_.get(translations, 'txt: Dzēst sarakstes', '')}
          </a>
        </div>
      );
    };

    const btnCancelEdit = function () {
      if (!showConversationsEditor) {
        return;
      }

      return (
        <div className="messagesSide-header-cancel">
          <a onClick={self._onClickCancelEdit} className="btn btn--small btn--b">
            {_.get(translations, 'txt: Atcelt', '')}
          </a>
        </div>
      );
    };

    const btnMarkAll = function () {
      let className = 'btn btn--small';
      if (data.get('checked').size === data.get('conversations').size) {
        className += ' btn--b all-selected';
      } else {
        className += ' btn--c';
      }

      return (
        <div key="convMarkAll">
          <a onClick={self._onClickMarkAll} className={className} >
            {_.get(translations, 'txt: Atzīmēt visas', '')}
          </a>
        </div>
      );
    };

    // Poga dzēst sarakstesz
    const btnDelete = function () {
      if (!data.get('checked').size) {
        return null;
      }

      return (
        <div key="convDelete" className="conversationsEditor-delete">
          <a onClick={self._onClickDelete} className="btn btn--small btn--delete">
            <div
              className="icon-trash-container"
            >
              <ImageSvg svg="icon-trash" full />
            </div>
            {_.get(translations, 'txt: Dzēst', '')}
          </a>
        </div>
      );
    };

    // Atzīmēto skaits
    const checkedCount = function () {
      if (!data.get('checked').size) {
        return null;
      }

      return (
        <span key="convCheckedCount" className="conversationsEditor-checked-count">
          {_.get(translations, 'txt: Atzīmētas', '')} {data.get('checked').size} / {data.get('conversations').size}
        </span>
      );
    };

    let totalUnread = '';
    if (data.get('unread') > 0) {
      totalUnread = data.get('unread');
    }
    /* this.scrollElement(); */

    const deletingInProgress = function () {
      if (!deleting) {
        return;
      }

      return (
        <div className="conversationsEditor-deleting-loader" />
      );
    };

    const header = () => {
      return (
        <div className="messagesSide-header" ref="header">
          <h2 className="messagesSide-header-title">{_.get(translations, 'txt: Sarakstes', '')} <span className="tcn">{totalUnread}</span></h2>
          {btnEdit()}
          {btnCancelEdit()}
          <CSSTransition
            in={showConversationsEditor}
            timeout={200}
            classNames="conversationsEditorTransition"
            unmountOnExit
          >
            <div key="convEditor" className="conversationsEditor">
              {btnMarkAll()}
              {btnDelete()}
              {checkedCount()}
            </div>
          </CSSTransition>
        </div>
      );
    };

    const scrollHeader = this.props.mobile;

    return (
      <div className="messagesSide">
        {deletingInProgress()}
        {scrollHeader ? '' : header()}
        <div style={{ maxHeight: scrollHeader ? '100%' : '80%' }}>
          <Scrollbars
            ref="conversationScroll"
            autoHeight
            autoHeightMax={data.get('scrollHeight')}
            autoHeightMin={data.get('scrollHeight')}
          >
          <div className="nano-content">
            {scrollHeader ? header() : ''}
            {conversationItems}
          </div>
          </Scrollbars>
        </div>
        {AdboxBlock()}
      </div>
    );
  }

  /**
   * Event handler for 'change' events coming from the stores
   */
  _onChange = () => {
    this.setImmState((data) => {
      const stateData = getStateFromStores();
      // pārveido par immutable MAP, lai būtu korekts merge
      const stateDataImm = Immutable.Map(stateData);
      return data.merge(stateDataImm);
    });
  };

  /**
   * Event handler for 'onClick'
   */
  _onClick = (id) => {
    ConversationActionCreators.clickConversation(id);
    GalleryStore.clearLocalImages();
    GalleryStore.emitChange();
  };

  /**
   * Event handler for 'onClick' load more
   */
  _onClickLoadMore = (e) => {
    e.preventDefault();

    const data = this.state.data;
    // info logs, ja nav abo
    if (data.get('limitedMessages')) {
      popup.subscriptionMessage();
      return;
    }

    const lastConversation = data.get('lastConversation');

    if (lastConversation) {
      ConversationActionCreators.conversationsLoadMore(lastConversation.get('updated'));
    }
  };

  /**
   * Event handler for 'onClick' - edit conversations
   */
  _onClickEdit = () => {
    this.setState({ conversationsEditor: true });
  };

  /**
   * Event handler for 'onClick' - cancel editing conversations
   */
  _onClickCancelEdit = () => {
    this.setState({ conversationsEditor: false });

    const data = this.state.data;
    const onChecked = this._onChecked.bind(this);

    if (data.get('total')) {
      data.get('conversations').toArray().map((conversation) => {
        const id = conversation.get('id');
        const eventSimulation = { target: { checked: false } };

        onChecked(id, eventSimulation);
      });
    }
  };

  /**
   * Event handler for 'onClick' - mark all conversations
   */
  _onClickMarkAll = () => {
    const data = this.state.data;
    const onChecked = this._onChecked.bind(this);

    if (data.get('total')) {
      let eventTarget = true;
      if (data.get('conversations').size === data.get('checked').size) {
        eventTarget = false;
      }

      data.get('conversations').toArray().map((conversation) => {
        const id = conversation.get('id');
        const eventSimulation = { target: { checked: eventTarget } };

        onChecked(id, eventSimulation);
      });
    }
  };

  /**
   * Event handler for 'onClick' - delete message
   */
  _onClickDelete = (conversationID) => {
    const data = this.state.data;
    const self = this;
    // info logs, ja nav abo
    if (data.get('limitedMessages')) {
      popup.subscriptionMessage();
      return;
    }

    modal.confirm(_.get(translations, 'txt: Vai tiešām dzēst?'),  (response) => {
      if (response) {
        ConversationActionCreators.deleteConversations();
      }
    });
  };

  /**
   * Event handler for 'onChange' - cheched
   */
  _onChecked = (conversationID, event) => {
    const data = this.state.data;
    // info logs, ja nav abo
    if (data.get('limitedMessages')) {
      popup.subscriptionMessage();
      return;
    }

    ConversationActionCreators.checkedConversation(conversationID, event.target.checked);
  };

  /**
  * Event handler for 'resize'
  */
  _onResize = () => {
    this.setScrollHeight();
  };
}

module.exports = ConversationSection;
